import { withStyles, WithStyles } from '@material-ui/core/styles'
import classNames from 'classnames'
import upperFirst from 'lodash/upperFirst'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { TemporalNow, epochToZonedDateTime, humanizedDuration } from 'src/commons/temporalHelpers'
import { BicycleIcon } from 'src/components/Devices'

import { IFeature, IGBFSProvider } from './types'
import { styles } from './VehiclePopup'

interface IProps extends WithStyles<typeof styles> {
  provider: IGBFSProvider
  station: IFeature
}

const BikeStationPopup = ({ classes, provider, station }: IProps) => {
  const { properties } = station
  const { address, lastReported, numBikesAvailable, numDocksAvailable } = properties
  const { t } = useTranslation()

  const now = TemporalNow()
  const lastReportedDiff = humanizedDuration(now.since(epochToZonedDateTime(lastReported * 1000)))

  const providerImage = `url(${provider ? provider.logo : '/img/img-placeholder.svg'})`

  return (
    <div className={classes.root}>
      <div className={classes.column}>
        <div style={{ backgroundImage: providerImage }} className={classes.media} />
      </div>
      <div className={classes.vertLine} />
      <div style={{ width: '100%' }}>
        <div className={classes.row}>
          <div className={classes.header}>
            <div className={classes.vehicleTitle}>{provider.name}</div>
            <div className={classes.row} style={{ height: 5 }} />
            <div className={classes.vehicleSubTitle}>{address}</div>
            <div className={classes.row} style={{ height: 5 }} />
            <div className={classNames(classes.row, classes.vehicleStatus)}>
              {t('dockedBikes', {
                available: numBikesAvailable,
                total: numBikesAvailable + numDocksAvailable,
              })}
            </div>
          </div>
          <BicycleIcon className={classes.vehicleIcon} />
        </div>
        <div className={classes.row} style={{ height: 10 }} />
        <div className={classes.row}>
          <div className={classNames(classes.row, classes.vehicleTelemetry)}>
            <div className={classes.lastTelemetryTxt}>{upperFirst(lastReportedDiff)}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withStyles(styles)(BikeStationPopup)
